import { observer } from 'mobx-react';
import { Component } from 'react';
import OrderRequestDelivery from '../OrderRequestDelivery/OrderRequestDelivery';
import AggregatorManager from '../../../../components/AggregatorManager/AggregatorManager';
import { withOrderStore } from '../../context';
import DeliveryCustomerInfo from './containers/DeliveryCustomerInfo/DeliveryCustomerInfo';
import DeliveryInfo from './containers/DeliveryInfo/DeliveryInfo';
import DeliveryRecipientInfo from './containers/DeliveryRecipientInfo/DeliveryRecipientInfo';
import { USER_PERMISSIONS } from 'src/constants/user';
import Permission from 'src/view/components/Permission/Permission';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { OrderStore } from '~/mobx/orderStore';

// @ts-ignore
@withOrderStore
@observer
export default class OrderDelivery extends Component<{ orderStore?: OrderStore }, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  render() {
    return (
      <ScrollableBlock>
        <div className="d-flex flex-row mt-3">
          <div className="mr-4">
            <AggregatorManager aggregator={this.orderStore.order?.aggregator_key} sectionName="delivery_recipient">
              {this.orderStore.order?.stranger_phone ? <DeliveryRecipientInfo /> : null}
            </AggregatorManager>
            <DeliveryCustomerInfo />
          </div>
          <AggregatorManager aggregator={this.orderStore.order?.aggregator_key} sectionName="delivery_managment">
            <div className="w-50">
              <Permission permissions={[USER_PERMISSIONS.ORDERS_DELIVERY[0], USER_PERMISSIONS.ORDERS_MANAGMENT[0]]}>
                <OrderRequestDelivery />
              </Permission>
              {this.orderStore.order?.takergo ? <DeliveryInfo /> : null}
            </div>
          </AggregatorManager>
        </div>
      </ScrollableBlock>
    );
  }
}
